import React from 'react';
import {
  ButtonBackData,
  PageLayout,
  BupSpinner,
  ErrorMessage,
  EndSurvey,
  PendingSurvey,
  StartSurvey,
  NoSurvey,
} from '@BUP/components';
import { useHistory } from 'react-router';
import {
  useAuth,
  useBraveUpSurveysApi,
  useGetSurveyCustomN,
  useGetSurveyRoles,
} from '@BUP/hooks';

const DataConfirmSurveyPage = () => {
  const history = useHistory();
  const { user } = useAuth();
  const roleId = user?.roles?.id;
  const rolName = user?.roles?.name;
  const { enrollmentId } = user;
  const { isLoadingSurvey, survey, errorSurvey } = useBraveUpSurveysApi();
  const surveyId = survey?.id;
  const folderID = survey?.folder_id_questionpro;
  const {
    isLoadingSurveyRoles,
    surveyRoles,
    errorSurveyRoles,
    isLoadingSurveyQP,
    surveyQP,
    errorSurveyQP,
  } = useGetSurveyRoles(surveyId, folderID, roleId, rolName);

  const urlSurveyRolesQP = surveyRoles?.questionproSurveyUrl;
  const urlSurveyRolesQPConcat = surveyRoles
    ? `${urlSurveyRolesQP}?custom1=${enrollmentId}`
    : undefined;

  const urlSurvey = surveyQP?.url;
  const urlSurveyConcat = `${urlSurvey}?custom1=${enrollmentId}`;
  const { isLoadingCustom, response } = useGetSurveyCustomN(surveyQP);
  const resStatus = response[0]?.responseStatus;
  const completionUrl = response[0]?.completionUrl;

  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />
      {isLoadingCustom ||
      isLoadingSurvey ||
      isLoadingSurveyRoles ||
      isLoadingSurveyQP ? (
        <BupSpinner size="large" />
      ) : errorSurvey ? (
        <ErrorMessage apiError={`Error-BUP-APi: ${errorSurvey.message}`} />
      ) : errorSurveyRoles ? (
        <ErrorMessage apiError={`Error-QP: ${errorSurveyRoles.message}`} />
      ) : errorSurveyQP ? (
        <ErrorMessage apiError={`Error-QP: ${errorSurveyQP.message}`} />
      ) : errorSurveyRoles ? (
        <ErrorMessage apiError={`Error-survey: ${errorSurveyRoles.message}`} />
      ) : urlSurveyRolesQPConcat ? (
        <StartSurvey userName={user?.name} surveyUrl={urlSurveyRolesQPConcat} />
      ) : !survey ||
        survey === undefined ||
        !surveyQP ||
        surveyQP === undefined ||
        !survey?.active ? (
        <NoSurvey userName={user?.name} />
      ) : resStatus === 'Completed' || resStatus === 'Terminated' ? (
        <EndSurvey userName={user?.name} />
      ) : resStatus === 'Started' ? (
        <PendingSurvey completionUrl={completionUrl} />
      ) : (
        <StartSurvey userName={user?.name} surveyUrl={urlSurveyConcat} />
      )}
    </PageLayout>
  );
};

export default DataConfirmSurveyPage;
